module.exports = __webpack_public_path__ + "static/media/nicaragua.7cad1a6f.svg";